import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import Cookie from "js-cookie";
import { EyeOutlined, EyeInvisibleOutlined } from "@ant-design/icons";
import { Card, Input, Button, Alert } from "antd";
import MainLayout from "../../components/layout";
import { role, token_leads, token_user } from "../../../../helpers/auth";
import OtpInput from "react-otp-input";
import { PremiumLayoutSkeleton } from "../../../../components/page-skeleton";
import { useHistory } from "react-router-dom";
import { useGoogleLogin } from "@react-oauth/google";
import GoogleIcon from "../../../../assets/images/google.png";
import { ArrowLeftOutlined } from "@ant-design/icons";

const LoginPage = () => {
  const resendTime = 10; // SECONDS
  const { http } = global.services;
  const history = useHistory();
  const [isAuthenicated, setAuthenicated] = useState(true);
  const [verificationView, setVerificationView] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [secondsRemaining, setSecondsRemaining] = useState(0);
  const [resendPreview, setResendPreview] = useState(false);
  const [sucessMessage, setsucessMessage] = useState("");
  const [user, setUser] = useState(null);
  const [otp, setOtp] = useState("");
  const [form, setForm] = useState({
    username: "",
    password: "",
    showPassword: false,
  });

  const [errors, setErrors] = useState({});
  const loginBtnRef = useRef();

  const onGoogleLogin = async (credentialResponse) => {
    const { access_token } = credentialResponse;
    setErrors({});
    try {
      const { data } = await http.post("google-login", {
        token: access_token,
      });
      Cookie.set("role", "leads");
      Cookie.set("token_leads", data.token);
      Cookie.set("is_logged_once", JSON.stringify(data.is_logged_once));
      Cookie.set("email", data.email);
      if (data.token) localStorage.setItem("modal", 1);
      if (data.is_logged_once === 0) {
        window.location.href = "/set-password";
      } else {
        // TODO: uncomment this when we restrict professional users from accessing enterprise features
        // window.location.href =
        //   data?.role === ENTERPRISE_ROLE ? "/leads" : "/leads/dataset";
        window.location.href = "/leads";
      }
    } catch (err) {
      const { data, status } = err.response;
      if (status === 400) {
        setErrors({ message: [data.error] });
      }
    }
  };
  const googleLogin = useGoogleLogin({
    flow: "auth-code",
    onSuccess: (tokenResponse) => {
      onGoogleLogin(tokenResponse);
    },
    onError: () => {
      console.error("Login Failed");
    },
    flow: "implicit",
    prompt: "select_account",
  });
  const onLogin = async () => {
    let error = "";
    try {
      let emailValidation =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      if (!emailValidation.test(form.username)) {
        setErrors({ message: ["Invalid email address"] });
        return;
      }

      let formData = {
        email: form.username.trim().toLowerCase(),
        password: form.password,
      };
      setLoading(true);
      localStorage.removeItem("selected_filters");
      localStorage.removeItem("viewable_filters");
      let { data } = await http.post("login", formData);
      setUser(data?.user_id);
      setLoading(false);
      setVerificationView(true);
    } catch (err) {
      setLoading(false);
      const { data, status } = err.response;
      error = { message: [data.error || "An error occurred"] };
      if (status === 400) {
        error = { message: data.non_field_errors };
      }
    }

    setErrors(error || {});
  };
  const onVerification = async () => {
    let error = "";
    try {
      setLoading(true);
      let { data } = await http.post(`otp-verification/${user}`, { otp: otp });
      setLoading(false);
      Cookie.set("role", "leads");
      Cookie.set("token_leads", data.token);
      Cookie.set("is_logged_once", JSON.stringify(data.is_logged_once));
      Cookie.set("email", data.email);
      if (data.token) localStorage.setItem("modal", 1);
      if (data.is_logged_once === 0) {
        window.location.href = "/set-password";
      } else {
        // TODO: uncomment this when we restrict professional users from accessing enterprise features
        // window.location.href = data?.role === ENTERPRISE_ROLE ? "/leads" : "/leads/dataset";
        window.location.href = "/leads";
      }
    } catch (err) {
      setLoading(false);
      const { data, status } = err.response;
      error = { message: [data.error || "An error occurred"] };
      if (status === 400) {
        error = { message: data.non_field_errors };
      }
    }

    setErrors(error || {});
  };
  const onResend = async () => {
    // let error = "";
    setResendPreview(true);
    setSecondsRemaining(resendTime);
    // try {
    //   await http.post(`resend-otp/${user}`);
    // } catch (err) {
    //   const { data, status } = err.response;
    //   if (status === 400) {
    //     error = { message: data.non_field_errors };
    //   }
    // }

    // setErrors(error || {});
  };
  const submitHandler = () => {
    if (verificationView) {
      onVerification();
      return;
    }
    onLogin();
  };

  useEffect(() => {
    const listener = (event) => {
      if (event.code === "Enter" || event.code === "NumpadEnter") {
        loginBtnRef.current.click();
      }
    };
    document.addEventListener("keydown", listener);
    return () => {
      document.removeEventListener("keydown", listener);
    };
  }, []);

  useEffect(() => {
    let intervalId;
    if (secondsRemaining > 0) {
      intervalId = setInterval(() => {
        setSecondsRemaining((prevSeconds) => Math.max(0, prevSeconds - 1));
      }, 1000);
    }

    return () => clearInterval(intervalId); // Cleanup the interval when the component unmounts or secondsRemaining changes
  }, [secondsRemaining]); // This will only run when `secondsRemaining` changes

  useEffect(() => {
    const resendCode = async () => {
      if (resendPreview && secondsRemaining === 0) {
        setResendPreview(false);
        setsucessMessage("");
        try {
          await http.post(`resend-otp/${user}`);
          setsucessMessage("Code sent successfully.");
          setTimeout(() => {
            setsucessMessage("");
          }, 5000);
        } catch (err) {
          const { data, status } = err.response;
          if (status === 400) {
            const error = { message: data.non_field_errors };
            setErrors(error || {});
          }
        }
      }
    };

    resendCode();
  }, [secondsRemaining, resendPreview]);

  useEffect(() => {
    const expirationTimestamp = localStorage.getItem("expirationTimestamp");
    if (expirationTimestamp && Date.now() > parseInt(expirationTimestamp, 10)) {
      Object.keys(Cookie.get()).forEach((cookieName) => {
        Cookie.remove(cookieName);
      });
      setAuthenicated(false);
    } else if (role === "leads" && token_leads) {
      history.replace("/leads");
    } else if (role === "user" && token_user) {
      history.replace("/home");
    } else {
      setAuthenicated(false);
    }
    localStorage.removeItem("expirationTimestamp");
  }, []);

  const change = (props) => (e) => {
    let data = { ...form };
    data[props] = e.target.value;
    setForm(data);
  };

  const formattedTime = `${Math.floor(secondsRemaining / 60)
    .toString()
    .padStart(2, "0")}:${secondsRemaining % 60 < 10 ? "0" : ""}${secondsRemaining % 60}`;

  if (isAuthenicated)
    return (
      <div className="loading-screen">
        <PremiumLayoutSkeleton />
      </div>
    );

  return (
    <React.Fragment>
      <MainLayout>
        <div className="flex justify-center items-center">
          <Card bordered={false}>
            <div className="flex-column items-center" style={{ padding: "40px 40px 60px" }}>
                <h1 className="form-title">
                  {verificationView ? "Verification Required" : "Login"}
                </h1>
              <p className="form-description">
                {verificationView ? (
                  `Enter the code sent to your email address.`
                ) : (
                  <>
                    Don't have an account yet? <Link to="signup">Signup</Link>
                  </>
                )}
              </p>
              {errors.message && (
                <>
                  <Alert
                    message={errors.message[0]}
                    style={{ width: "100%", textAlign: "center" }}
                    type="error"
                  />
                  <br />
                </>
              )}
              {sucessMessage && (
                <>
                  <Alert
                    message={sucessMessage}
                    style={{ width: "100%", textAlign: "center" }}
                    type="success"
                  />
                  <br />
                </>
              )}
              <div className="flex flex-column flex-grow" style={{ width: 300 }}>
                {verificationView ? (
                  <>
                    <OtpInput
                      containerStyle="otp-container"
                      inputStyle="otp-input"
                      value={otp}
                      onChange={setOtp}
                      numInputs={6}
                      renderSeparator={<span></span>}
                      renderInput={(props) => <input {...props} />}
                      inputType="tel"
                      shouldAutoFocus={verificationView}
                    />
                    <p className="resend-otp">
                      {secondsRemaining > 0 ? (
                        <>The code will be sent in {formattedTime}.</>
                      ) : (
                        <>
                          Didn't recieve a code?{" "}
                          <span onClick={onResend} className={`resend-btn`}>
                            Resend
                          </span>
                        </>
                      )}
                    </p>
                  </>
                ) : (
                  <>
                    <div style={{ marginBottom: 16 }}>
                      <span style={{ display: "block" }}>Email Address</span>
                      <Input
                        value={form.username}
                        className="inputs"
                        placeholder=""
                        onChange={change("username")}
                      />
                    </div>
                    <div style={{ marginBottom: verificationView ? 32 : 24 }}>
                      <div className="flex justify-between">
                        <span>Password</span>
                        <Link to="/forgot-password" style={{ color: "#605BFF" }}>
                          Forgot Password?
                        </Link>
                      </div>
                      <Input.Group compact>
                        <Input
                          value={form.password}
                          type={form.showPassword ? "text" : "password"}
                          className="inputs"
                          onChange={change("password")}
                          suffix={
                            form.showPassword ? (
                              <EyeInvisibleOutlined
                                onClick={() => setForm({ ...form, showPassword: false })}
                              />
                            ) : (
                              <EyeOutlined
                                onClick={() => setForm({ ...form, showPassword: true })}
                              />
                            )
                          }
                        />
                      </Input.Group>
                    </div>
                  </>
                )}
                <Button
                  type="primary"
                  block
                  loading={isLoading}
                  ref={loginBtnRef}
                  style={{
                    color: "#fff",
                    borderColor: "#c6b4f3",
                    backgroundColor: "#c6b4f3",
                    borderRadius: 8,
                    height: 38,
                  }}
                  onClick={submitHandler}
                >
                  {verificationView ? "Verify code" : "Login"}
                </Button>
                {!verificationView && (
                  <>
                    <div className="or-seperator">
                      <span>Or</span>
                    </div>
                    <button className="google-login-btn" onClick={googleLogin}>
                      <img src={GoogleIcon} alt="Google" />
                      <span>Sign in with Google</span>
                    </button>
                  </>
                )}
                {verificationView && (
                  <button
                    type="button"
                    className="auth-back-btn"
                    onClick={() => setVerificationView(false)}
                  >
                    <ArrowLeftOutlined /> Back to Login
                  </button>
                )}
              </div>
            </div>
          </Card>
        </div>
      </MainLayout>
    </React.Fragment>
  );
};

export default LoginPage;
